/**
 * Toplu belge silme işlemi
 * 
 * @param {Object} options - Yapılandırma seçenekleri
 * @param {Object} options.axios - Axios örneği
 * @param {Object} options.settings - URL ayarları
 * @param {String} options.assetId - Varlık ID'si
 * @param {Array} options.documentIds - Silinecek belge ID'leri
 * @returns {Promise<Object>} - API yanıtı
 */
export const bulkDeleteDocuments = async (options) => {
  const { axios, settings, assetId, documentIds } = options;
  
  if (!documentIds || documentIds.length === 0) {
    throw new Error('Silinecek belge bulunamadı');
  }
  
  try {
    const response = await axios.put(settings.bulkDeleteDocumentFiles, {
      assetId,
      fileIds: documentIds
    });
    
    return response.data;
  } catch (error) {
    console.error('Belgeler toplu silinirken hata oluştu:', error);
    throw error;
  }
};